module.exports = __webpack_public_path__ + "images/[10]20250124_145817.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/slider/[10]20250124_145817.jpg
// module id = 41
// module chunks = 0